import React from 'react';
import classNames from 'classnames';

import Trans from 'components/Common/Translation/Trans';
import PaImg from 'assets/img/personnal-account-desk.jpg';
import PaPicto from 'assets/img/picto-personal-account.png';

import styles from './PaBanner.module.scss';

type Props = {
  classes?: Partial<{
    wrapper: string;
  }>;
};

export default function PaBanner({ classes }: Props): JSX.Element {
  return (
    <div className={classNames(styles.pageMain, classes?.wrapper)}>
      <div className={styles.container}>
        <img className={styles.paImg} src={PaImg} alt="personal-account" />
        <img className={styles.paPicto} src={PaPicto} alt="pa-picto" />
        <div className={styles.textContainer}>
          <div className={styles.title}>
            <Trans i18nKey={'LABEL_PA_BANNER_TITLE'} namespace={'signUpPage'} />
          </div>
          <span className={styles.text1}>
            <Trans
              i18nKey={'LABEL_PA_BANNER_ONLINE_PAYMENT'}
              namespace={'signUpPage'}
            />
          </span>
          <span>
            <Trans
              i18nKey={'LABEL_PA_BANNER_CREATE_ACCOUNT'}
              namespace={'signUpPage'}
            />
          </span>
        </div>
      </div>
    </div>
  );
}
